module.exports = __webpack_public_path__ + "img/Logo_black.68295cc4.png";